import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeSection = ({ user, stats }) => {
  const currentHour = new Date()?.getHours();
  const getGreeting = () => {
    if (currentHour < 12) return 'Good morning';
    if (currentHour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  const statCards = [
    {
      id: 'analyzed',
      label: 'Bikes Analyzed',
      value: stats?.bikesAnalyzed,
      icon: 'Bike',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'recommendations',
      label: 'Recommendations',
      value: stats?.recommendationsReceived,
      icon: 'Zap',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    },
    {
      id: 'saved',
      label: 'Money Saved',
      value: `$${stats?.moneySaved?.toLocaleString()}`,
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-6">
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-foreground mb-2">
            {getGreeting()}, {user?.name}!
          </h1>
          <p className="text-muted-foreground">
            Ready to optimize your bike setup? Let's find your next upgrade.
          </p>
        </div>
        <div className="mt-4 lg:mt-0 flex items-center space-x-3">
          <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center">
            <Icon name="User" size={24} color="var(--color-accent)" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">{user?.email}</p>
            <p className="text-xs text-muted-foreground">
              Member since {new Date(2024, 0, 15)?.toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {statCards?.map((stat) => (
          <div key={stat?.id} className="bg-background border border-border rounded-lg p-4">
            <div className="flex items-center space-x-3">
              <div className={`w-10 h-10 ${stat?.bgColor} rounded-lg flex items-center justify-center`}>
                <Icon name={stat?.icon} size={20} className={stat?.color} />
              </div>
              <div>
                <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
                <p className="text-sm text-muted-foreground">{stat?.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WelcomeSection;